import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  subAdmin: [],
  allSubAdmin: [],
  addSubAdminData: []
};

export const SubAdminSlice = createSlice({
  name: "subAdmin",
  initialState,
  reducers: {
    getAllSubAdminAction: (state, action) => {
      
      state.allSubAdmin = action.payload;
    },
    getSingleSubAdminAction: (state, action) => {
      
      state.subAdmin = action.payload;
    },
    getAddSubAdminDataAction: (state, action) => {
      
      state.addSubAdminData = action.payload;
    }
  },
});

export default SubAdminSlice.reducer;

export const { getAllSubAdminAction, getSingleSubAdminAction, getAddSubAdminDataAction } = SubAdminSlice.actions;
